import type { PropertyType } from '../../core/models/property-type.model';
import type { Entity } from '../../core/models/entity.model';

export function getTooltipTextId(propertyType: PropertyType): string {
  return (propertyType.MetaData['ToolTipTextId'] as string) || null;
}

export type PropertyComponentType =
  | 'button'
  | 'checkbox'
  | 'datepicker'
  | 'boolean-button'
  | 'numeric'
  | 'password'
  | 'select'
  | 'text'
  | 'textbox';

const uiPresentationFlag = 'UIPresentation';

export const resolveComponentType = (entity: Entity, propertyType: PropertyType): PropertyComponentType => {
  if (!entity || !propertyType) {
    return 'text';
  }

  const property = entity.Properties[propertyType.Key];

  if (property.Items && property.Items.length > 0) {
    return 'select';
  }

  const valueType = propertyType.ValueType;

  if (valueType === 'Double' || valueType === 'Int') {
    return 'numeric';
  }

  if (valueType === 'Boolean') {
    if (propertyType.MetaData[uiPresentationFlag] === 'BooleanButton') {
      return 'boolean-button';
    }
    return 'checkbox';
  }

  if (valueType === 'String') {
    if (propertyType.MetaData[uiPresentationFlag] === 'Button') {
      return 'button';
    }
    if (propertyType.MetaData[uiPresentationFlag] === 'Password') {
      return 'password';
    }
    if (propertyType.MetaData[uiPresentationFlag] === 'TextBox') {
      return 'textbox';
    }
    return 'text';
  }

  if (valueType === 'DateTime') {
    return 'datepicker';
  }

  return 'text';
};
